export function isAddPaymentMethodSubmitBusy({
  isCreatingSetupIntent,
  isCompletingSetupIntent,
  isProcessing,
}: {
  isCreatingSetupIntent: boolean;
  isCompletingSetupIntent: boolean;
  isProcessing: boolean;
}): boolean {
  return isCreatingSetupIntent || isCompletingSetupIntent || isProcessing;
}
